export enum BrandingTabEnum {
  Design = 'design',
  Domain = 'domain',
}
